import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

import "./EditProfile.scss";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import BadgesEllipsis from "../../components/Common/BadgesEllipsis";
import ProfilePicture from "../../components/Common/ProfilePicture";

// actions
import {
  getEditProfile,
  editEditProfile,
  resetEditProfile,
  resetError,
} from "../../store/editprofile/actions";

import { updateUserSuccess } from "../../store/auth/login/actions";

const EditProfile = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { data } = useSelector((state) => state.Login);

  const {
    dataEditProfileGetSet,
    dataEditProfileEditCreate,
    loadingEditProfile,
    loadingEditProfileEditCreate,
    successEditProfile,
    errorEditProfile,
  } = useSelector((state) => state.EditProfile);

  const [editProfileValues, setEditProfileValues] = useState({
    name: "",
    email: "",
    nickname: "",
    nicknameBk: "",
    profiles: [],
    url_avatar: "",
  });

  const [idEditProfile, setIdEditProfile] = useState("");
  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleEditProfile = () => {
    if (idEditProfile) {
      dispatch(editEditProfile(idEditProfile, newFields));
    } else {
    }
  };

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      onHidden: () =>
        successEditProfile &&
        dispatch(resetEditProfile()) &&
        history.push("/dashboard"),
    };
    toastr[type](message);
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetEditProfile());
    if (data && data.user && data.user.id) {
      setIdEditProfile(data.user.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idEditProfile) {
      dispatch(getEditProfile(idEditProfile, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idEditProfile]);

  useEffect(() => {
    if (idEditProfile && dataEditProfileGetSet?.data?.user) {
      setEditProfileValues((previous) => ({
        ...previous,
        name: dataEditProfileGetSet.data.user.name,
        email: dataEditProfileGetSet.data.user.email,
        nickname: dataEditProfileGetSet.data.user.nickname,
        nicknameBk: dataEditProfileGetSet.data.user.nickname,
        profiles: dataEditProfileGetSet.data.user.profiles,
        url_avatar:
          dataEditProfileGetSet.data.user.url_avatar +
          "?time=" +
          new Date().getTime(),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataEditProfileGetSet]);

  useEffect(() => {
    if (dataEditProfileEditCreate?.message) {
      showToast("success", t(dataEditProfileEditCreate.message));
      dataEditProfileEditCreate?.url_avatar &&
        dispatch(
          updateUserSuccess(
            editProfileValues?.name,
            editProfileValues?.nickname,
            dataEditProfileEditCreate.url_avatar +
              "?time=" +
              new Date().getTime()
          )
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successEditProfile]);

  useEffect(() => {
    if (errorEditProfile && typeof errorEditProfile === "object") {
      errorEditProfile.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorEditProfile) {
        showToast("error", t(errorEditProfile));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorEditProfile]);

  const fileToBase64 = async (file) => {
    const result_base64 = await new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = (e) => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64;
  };

  const handleProfilePicture = async (file) => {
    let fileSplit = file.type.split("/");
    if (fileSplit[0] === "image" && fileSplit[1].match(/(jpeg|jpg|gif|png)$/)) {
      const fileBase64 = await fileToBase64(file);
      setNewFields({
        ...newFields,
        avatar: fileBase64 + "?" + new Date().getTime(),
      });

      Object.assign(file, {
        preview: URL.createObjectURL(file),
      });
      setEditProfileValues({
        ...editProfileValues,
        url_avatar: file.preview,
      });
    } else {
      showToast("error", t("Format not suported"));
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/edit-profiles"
            path={"/edit-profile"}
            title={t("Edit Profile")}
            breadcrumbItem={t("Edit Profile")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <Row className="d-flex">
                    <Col
                      md="6"
                      sm="12"
                      className="mb-3 d-flex align-items-center"
                    >
                      <div
                        className="d-flex"
                        isDisabled={loadingEditProfile}
                        //Descomente caso queira que exclua a foto no clicar (verificar se api permite)
                        // onClick={() => {
                        //   if (editProfileValues.url_avatar) {
                        //     //"remove"
                        //     setEditProfileValues({
                        //       ...editProfileValues,
                        //       url_avatar: null,
                        //     });
                        //     setNewFields({
                        //       ...newFields,
                        //       avatar: "",
                        //     });
                        //   } else {
                        //     //"add"
                        //   }
                        // }}
                      >
                        <label
                          className="m-0"
                          htmlFor={!loadingEditProfile ? "file" : undefined}
                        >
                          <ProfilePicture
                            name={editProfileValues.name}
                            src={editProfileValues.url_avatar}
                            sizePx={100}
                            customStyle={"profile-picture-edit"}
                          />
                        </label>
                        <input
                          type="file"
                          id="file"
                          onChange={(e) => {
                            e.target.files.length &&
                              handleProfilePicture(e.target.files[0]);
                          }}
                          style={{ display: "none" }}
                        />
                      </div>
                      <div className="ml-3 overflow-auto">
                        <h2 className="font-size-18 mb-1 text-truncate">
                          {editProfileValues.name}
                        </h2>
                        <h5 className="font-size-14 text-muted mb-1 text-truncate">
                          {editProfileValues.nickname}
                        </h5>
                        <p className="text-muted mb-1 text-truncate">
                          {editProfileValues.email}
                        </p>
                        <BadgesEllipsis objItems={editProfileValues.profiles} />
                      </div>
                    </Col>
                  </Row>
                  <AvForm onValidSubmit={handleEditProfile}>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            label={t("Nickname") + " *"}
                            id="nickname"
                            name="nickname"
                            type="text"
                            className="form-control"
                            placeholder={t("EditProfile nickname")}
                            onChange={(e) => {
                              setEditProfileValues({
                                ...editProfileValues,
                                nickname: e.target.value,
                              });
                              if (
                                e.target.value === editProfileValues.nicknameBk
                              ) {
                                delete newFields.nickname;
                                checkSubmit();
                              } else {
                                setNewFields({
                                  ...newFields,
                                  nickname: e.target.value,
                                });
                              }
                            }}
                            value={
                              loadingEditProfile
                                ? `${t("Loading")}...`
                                : editProfileValues.nickname
                            }
                            disabled={loadingEditProfile}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i",
                                errorMessage: t(
                                  "Nickname must be composed only with letters and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 54,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup className="waves-effect w-100">
                          <Link
                            to={`/reset-password/${
                              JSON.parse(
                                localStorage.authUser
                              ).Authorization.split(" ")[1]
                            }`}
                          >
                            <Button
                              type="button"
                              color="primary"
                              className="form-control waves-effect update-password-button"
                            >
                              {t("Update password")}
                            </Button>
                          </Link>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingEditProfileEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link onClick={() => history.goBack()}>
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetEditProfile())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(EditProfile);
